import { ObjectHistoryLogObjectType } from './HistoryLogObjectType';

const BuyerOptionGroup = ['Created', 'Approved', 'Unpublished', 'Rejected', 'ChangedSelection', 'Unlinked'] as const;

const ChangeRequest = [
    'Submitted',
    'Created',
    'Closed',
    'Reopened',
    'SplitFrom',
    'SplitInto',
    'MergedInto',
    'MergedFrom',
    'OfferSent',
    'ParticipantOfferChanged',
    'ParticipantReadyChanged',
    'ParticipantAdded',
    'ParticipantRemoved',
    'AttachmentAdded',
    'AttachmentUpdated',
    'OfferSigned',
    'OfferRejected',
    'SetArchived',
    'SetUnArchived',
    'BuyerOfferRetracted',
    'SetChangeRequestTags',
    'CreatedOffer',
    'UpdatedOffer',
    'SetOptionOverrides',
    'Edited',
] as const;

const CommentThread = ['Created', 'FollowersAdded', 'FollowersRemoved'] as const;

const Document = [
    'Uploaded',
    'Approved',
    'Rejected',
    'Created',
    'Renamed',
    'SetIsHiddenFromBuyer',
    'SetIsSensitive',
    'SetIsArchived',
    'NewRevision',
    'LinkAdded',
    'LinkRemoved',
] as const;

const ExternalAgreement = [
    'Rejected',
    'Created',
    'Updated',
    'Approved',
    'CreatedNewChangeRequest',
    'SetTags',
    'Canceled',
    'Reopened',
    'FileDeleted',
    'FileAdded',
    'FileChanged',
    'ParticipantAdded',
    'ParticipantRemoved',
    'LineUpdated',
    'LineRemoved',
    'LineCreated',
] as const;

const Order = [
    'Created',
    'Approved',
    'Rejected',
    'Canceled',
    'ExcludeFromRoomFormChanged',
    'SetResponsible',
    'OrderLineNoteChanged',
    'OrderLineNoteDeleted',
] as const;

const Project = [
    'DeadlineCreated',
    'DeadlineDeleted',
    'DeadlineUpdated',
    'LandingPageMilestonesUpdated',
    'LandingPageMessageCreated',
    'LandingPageMessageDeleted',
    'LandingPageMessageUpdated',
    'LandingPageImageAdded',
    'LandingPageImageDeleted',
    'InvitedMember',
    'CancelledInvitation',
    'ResendInvitation',
    'InvitationAccepted',
    'WhiteLabelUpdated',
    'CreatedProject',
    'ProjectSettingsUpdated',
    'PricingFieldDeleted',
    'PricingFieldCreated',
    'PricingFieldUpdated',
    'TermsUpdated',
    'ProjectTermsAndConditionsUpdated',
    'ProjectOptionTermsUpdated',
    'DeadlineAlertUpdated',
    'DeadlineAlertCreated',
    'FeeSetUpdated',
    'FeeSetDeleted',
    'FeeSetCreated',
    'LandingPageMilestoneCreated',
    'LandingPageMilestoneDeleted',
    'LandingPageImageTextChange',
    'LandingPageImageOrderChange',
    'FeatureUpdated',
    'TagCreated',
    'TagsDeleted',
    'TagUpdated',
    'ResidentialUnitGroupDeadlineCreated',
    'ResidentialUnitGroupDeadlineUpdated',
    'RemovedMember',
    'ConstructionPhaseAdded',
    'ConstructionPhaseUpdated',
    'ConstructionPhaseDeleted',
    'ResidentialUnitGroupCreated',
    'ResidentialUnitGroupDeleted',
    'ResidentialUnitGroupUpdated',
    'LandingPageSettingsUpdated',
    'LandingPageSettingsReset',
    'LandingPageContactEdited',
    'LandingPageContactAdded',
    'DocumentsBulkApproved',
    'DocumentsBulkRejected',
] as const;

const ProjectCatalogLinkGroup = [
    'Updated',
    'SetFees',
    'DuplicatedFrom',
    'Linking',
    'Unlinking',
    'ProductChanged',
    'ProductStyleAdded',
    'ProductStyleRemoved',
    'ProductStyleChanged',
    'ProductRemoved',
    'ProductAdded',
    'ProductSetDefault',
];

const ResidentialUnit = [
    'Created',
    'BuyerModuleRemoved',
    'Delete',
    'BuyerRemoved',
    'BuyerInvited',
    'SignedOptions',
    'DeadlineCreated',
    'DeadlineUpdated',
    'ExtraCostCreated',
    'ExtraCostUpdated',
    'ExtraCostsDeleted',
    'PricingFieldValueSet',
    'Updated',
    'BuyerInvitationCancelled',
    'BuyerAcceptedInvitation',
    'BuyerInvitationUpdated',
    'BuyerAddedWithoutInvite',
] as const;

const Email = [
    'ResetPassword',
    'InviteBuyer',
    // 'InviteToProject',
    'InviteToProfile',
    'MentionInComment',
    'ConfirmEmail',
    'WeeklyDigest',
    'NewLandingPageMessage',
    'MeetingReminder',
    'UnreadMessages',
    'NewDocumentAdded',
    'NewMessage',
    'ChangeRequestOffer',
    'ChangeRequestClosed',
    'ChangeRequestParticipantAdded',
    'ChangeRequestRequestedNewOffers',
    'ChangeRequestOfferAcceptedByBuyer',
    'ChangeRequestOfferRejectedByBuyer',
    'CM-ProjectMemberAdded',
    'RejectedBuyerOptionGroup',
    'RejectedExternalAgreement',
    'RejectedDocument',
    'DeadlineReminderWithUnsent',
    'DeadlineReminderAllSent',
    'DeadlineReminderNoOptions',
    'DeadlineReminderExpiredDeadline',
    'OrderConfirmation',
] as const;

const Sms = [
    'InviteBuyer',
    'OneTimeCode',
    'NewLandingPageMessage',
    'MeetingReminder',
    'NewMessage',
    'DeadlineReminderWithUnsent',
    'DeadlineReminderAllSent',
    'DeadlineReminderNoOptions',
    'DeadlineReminderExpiredDeadline',
] as const;

const Dependency = ['Created', 'Updated', 'Deleted'] as const;

const OptionPresetGroup = ['Updated', 'Created', 'Deleted', 'Reordered'] as const;
const OptionPreset = ['Deleted', 'Created', 'Updated', 'Published', 'Unpublished', 'ItemsUpdated'] as const;

const allActions = [
    ...BuyerOptionGroup,
    ...ChangeRequest,
    ...CommentThread,
    ...Document,
    ...Order,
    ...Project,
    ...ResidentialUnit,
    ...ExternalAgreement,
    ...ProjectCatalogLinkGroup,
    ...Email,
    ...Sms,
    ...Dependency,
] as const;

type HistoryLogActionsType = {
    [key in ObjectHistoryLogObjectType]: readonly string[];
};

export const historyLogActions: HistoryLogActionsType & { All: readonly string[] } = {
    BuyerOptionGroup,
    ChangeRequest,
    CommentThread,
    // Document,
    ProjectDocument: Document,
    ResidentialUnitDocument: Document,
    Order,
    Project,
    ResidentialUnit,
    ExternalAgreement,
    ProjectCatalogLinkGroup,
    Email,
    Sms,
    OptionPresetGroup,
    OptionPreset,
    Dependency,
    All: allActions,
};

/**
 * const example: HistoryLogAction['Order'] = 'Approved';
 */
export interface HistoryLogActions {
    BuyerOptionGroup: (typeof BuyerOptionGroup)[number];
    ChangeRequest: (typeof ChangeRequest)[number];
    CommentThread: (typeof CommentThread)[number];
    Document: (typeof Document)[number];
    ExternalAgreement: (typeof ExternalAgreement)[number];
    Order: (typeof Order)[number];
    Project: (typeof Project)[number];
    ResidentialUnit: (typeof ResidentialUnit)[number];
    ProjectCatalogLinkGroup: (typeof ProjectCatalogLinkGroup)[number];
    Email: (typeof Email)[number];
    Sms: (typeof Sms)[number];
    All: (typeof allActions)[number];
}
